module.exports = __webpack_public_path__ + "img/11.f22dbc59.png";